/**
 * Inline styles of LoginForm. Sizes that change with the viewport are CSS
 * variables from login.css (`.mklogin-form[data-density]`).
 */

import { ld } from "@/lib/theme/light-dark";
import type { CSSProperties } from "react";
import { INK, INPUT_BG, INPUT_BORDER } from "./login-shared";

export const LABEL_STYLE: CSSProperties = {
  fontFamily:
    "var(--font-inter), system-ui, -apple-system, 'Segoe UI', sans-serif",
  fontSize: 10,
  letterSpacing: "0.11em",
  textTransform: "uppercase",
  color: ld("rgba(11,15,25,0.5)", "rgba(250,250,250,0.5)"),
};

export const ICON_WRAP_STYLE: CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "var(--mklogin-icon-left)",
  transform: "translateY(-50%)",
  color: ld("rgba(11,15,25,0.4)", "rgba(250,250,250,0.4)"),
  display: "inline-flex",
  pointerEvents: "none",
};

export const INPUT_BASE_STYLE: CSSProperties = {
  width: "100%",
  height: "var(--mklogin-input-h)",
  boxSizing: "border-box",
  border: `1px solid ${INPUT_BORDER}`,
  borderRadius: "var(--mklogin-input-r)",
  background: INPUT_BG,
  fontSize: 14.5,
  fontFamily: "inherit",
  color: INK,
  outline: "none",
};

export const TOGGLE_STYLE: CSSProperties = {
  position: "absolute",
  right: "var(--mklogin-toggle-right)",
  top: "50%",
  transform: "translateY(-50%)",
  width: 34,
  height: 34,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  color: ld("rgba(11,15,25,0.45)", "rgba(250,250,250,0.45)"),
  borderRadius: 8,
  padding: 0,
  transition: "background .12s, color .12s",
};

export const ERROR_TONE_STYLE: CSSProperties = {
  border: `1px solid ${ld("rgba(192,57,43,0.28)", "rgba(246,134,117,0.35)")}`,
  background: ld("rgba(192,57,43,0.06)", "rgba(246,134,117,0.08)"),
  color: ld("#a23b2e", "#f68675"),
};

export const BANNER_STYLE: CSSProperties = {
  padding: "10px 14px",
  borderRadius: 10,
  fontSize: 13,
};
